// src/pages/dashbord/section/IncomeSection.tsx
import React from 'react';
import { Row, Col } from 'antd';
import RevenueKPI from '../../../components/RevenueKPI';
import RevenueSplitDonut from '../../../components/RevenueSplitDonut';
import RevenueAllTimeChart from '../../../components/RevenueAllTimeChart';
import TopProductsChart from '../../../components/TopProductsChart';
import TopBuyersChart from '../../../components/TopBuyersChart';

type Props = {
  ordersFiltered: any[];
  revenueSeries: Array<{ date: string; revenue: number; cumulative: number }>;
};

const RevenueSection: React.FC<Props> = ({ ordersFiltered, revenueSeries }) => {
  return (
    <>
      <div style={{ marginTop: 16 }}>
        <RevenueKPI source={ordersFiltered as any} />
      </div>

      <Row gutter={[16, 16]} style={{ marginTop: 28 }}>
        <Col xs={24} md={12} lg={10}>
          <RevenueSplitDonut height={420} rangeDays={30} />
        </Col>
        <Col xs={24} md={12} lg={14}>
          <RevenueAllTimeChart data={revenueSeries} height={420} />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} md={12}>
          <TopProductsChart topN={10} />
        </Col>
        <Col xs={24} md={12}>
          <TopBuyersChart topN={10} />
        </Col>
      </Row>
    </>
  );
};

export default RevenueSection;
